"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserNotifications = exports.TrackEventEventType = void 0;
// Vendor
const react_1 = require("react");
// Events
const eventBus_1 = require("../../../eventBus");
// Types
const features_1 = require("../../../features");
// Tracking
const tracker_1 = require("../../../tracker");
var TrackEventEventType;
(function (TrackEventEventType) {
    TrackEventEventType["NOTIFICATION_SUCCESS_OPEN"] = "NOTIFICATION_SUCCESS_OPEN";
    TrackEventEventType["NOTIFICATION_SUCCESS_CLOSE"] = "NOTIFICATION_SUCCESS_CLOSE";
    TrackEventEventType["NOTIFICATION_ERROR_OPEN"] = "NOTIFICATION_ERROR_OPEN";
    TrackEventEventType["NOTIFICATION_ERROR_CLOSE"] = "NOTIFICATION_ERROR_CLOSE";
    TrackEventEventType["REQUEST_NOTIFICATION"] = "REQUEST_NOTIFICATION";
})(TrackEventEventType = exports.TrackEventEventType || (exports.TrackEventEventType = {}));
const useAuthoriserNotifications = () => {
    const [isSuccessfulNotification, setIsSuccessfulNotification] = (0, react_1.useState)(false);
    const [challengeResent, setChallengeResent] = (0, react_1.useState)(false);
    const [currentEvent, setCurrentEvent] = (0, react_1.useState)(null);
    const pathname = location.pathname;
    const validChallengesResent = [
        features_1.ChallengeType.OTP,
        features_1.ChallengeType.OTP_LOGIN,
        features_1.ChallengeType.TRUSTED_CONFIRMATION,
        features_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN,
    ];
    const trackEvent = (trackEvent, event) => {
        const action = features_1.AuthoriserTrackingActions[trackEvent][event.challenge];
        if (action) {
            tracker_1.tracker.track(action, pathname);
        }
    };
    const onChallengeResent = (callback) => (0, eventBus_1.subscribeResentChallengeEvent)(callback);
    const handleCloseNotification = () => {
        setChallengeResent(false);
        if (currentEvent) {
            trackEvent(currentEvent.success ? TrackEventEventType.NOTIFICATION_SUCCESS_CLOSE : TrackEventEventType.NOTIFICATION_ERROR_CLOSE, currentEvent);
        }
    };
    (0, react_1.useEffect)(() => {
        return onChallengeResent((event) => {
            setCurrentEvent(event);
            if (validChallengesResent.includes(event.challenge)) {
                setChallengeResent(true);
                trackEvent(TrackEventEventType.REQUEST_NOTIFICATION, event);
            }
            setIsSuccessfulNotification(event.success);
            trackEvent(event.success ? TrackEventEventType.NOTIFICATION_SUCCESS_OPEN : TrackEventEventType.NOTIFICATION_ERROR_OPEN, event);
        });
    }, []);
    return {
        notifications: {
            challengeResent,
        },
        isSuccessfulNotification,
        handleCloseNotification,
    };
};
exports.useAuthoriserNotifications = useAuthoriserNotifications;
exports.default = exports.useAuthoriserNotifications;
//# sourceMappingURL=useAuthoriserNotifications.hook.js.map